import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { fetchPowerBIEmbedToken } from '../../services/api';
import './ManagementReports.css';

const workspaceId = process.env.REACT_APP_MANAGEMENT_DASHBOARD_WORKSPACE_ID || '';
const reportId = process.env.REACT_APP_MANAGEMENT_DASHBOARD_REPORT_ID || '';

const ManagementDashboard: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [embedToken, setEmbedToken] = useState<string | null>(null);
  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  // Map i18n language to Power BI locale format
  const getPowerBILocale = () => {
    const lang = i18n.language || 'en';
    const localeMap: Record<string, { language: string; formatLocale: string }> = {
      'en': { language: 'en-US', formatLocale: 'en-US' },
      'de': { language: 'de-DE', formatLocale: 'de-DE' },
    };
    return localeMap[lang] || localeMap['en'];
  };
  
  const localeSettings = getPowerBILocale();

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);
    fetchPowerBIEmbedToken(reportId, workspaceId, 'Report')
      .then(data => {
        if (!isMounted) return;
        const token = data.accessToken || '';
        const url = Array.isArray(data.embedUrl) && data.embedUrl[0]?.embedUrl ? data.embedUrl[0].embedUrl : '';
        setEmbedToken(token);
        setEmbedUrl(url);
        setLoading(false);
      })
      .catch(() => {
        if (!isMounted) return;
        setError(t('management.failedToLoadDashboard'));
        setLoading(false);
      });
    return () => { isMounted = false; };
  }, []);

  if (loading) {
    return (
      <div className="management-dashboard__loading">
        <span>{t('management.loadingDashboard')}</span>
      </div>
    );
  }
  if (error) {
    return (
      <div className="management-dashboard__error">{error}</div>
    );
  }
  if (!embedToken || !embedUrl) {
    return null;
  }
  return (
    <div className="management-reports">
      <PowerBIEmbed
        embedConfig={{
          type: 'report',
          id: reportId,
          embedUrl: embedUrl,
          accessToken: embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: { filters: { visible: false }, pageNavigation: { visible: false } },
            localeSettings: localeSettings
          },
        }}
        cssClassName="powerbi-embed"
      />
    </div>
  );
};

export default ManagementDashboard; 